import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useUnmount, useUpdateEffect } from 'react-use';

import { AppState } from 'bootstrap.store';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { useCommandHandler } from 'utils/commands';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { actions } from '../../../../../actions/conversation';

export const ConversationFocusModeButton = (): JSX.Element | null => {
  const dispatch = useAppDispatch();

  const { isFocusMode, csid, channel } = useAppSelector((state: AppState) => ({
    isFocusMode: state.conversation.isFocusMode,
    csid: state.conversation.metaConversation.conversation.id,
    channel: state.conversation.metaConversation.conversation.initial_channel,
  }));

  useCommandHandler({
    name: 'conversation:toggleConversationFocusMode',
    actionFn: () => {
      ampli.conversationFocusModeToggled({
        enabled: !isFocusMode,
        source: 'keyboardShortcut',
        channel: channel ?? '',
      });
      dispatch(actions.conversationToggleFocusMode());
    },
  });

  const toggleExpandedView = () => {
    ampli.conversationFocusModeToggled({
      enabled: !isFocusMode,
      source: 'button',
      channel: channel ?? '',
    });
    dispatch(actions.conversationToggleFocusMode());
  };

  useUnmount(() => {
    if (isFocusMode) {
      // When leaving the conversation, turn off focus mode
      dispatch(actions.conversationToggleFocusMode(false));
    }
  });

  useUpdateEffect(() => {
    if (isFocusMode) {
      // When moving to a another conversation, turn off focus mode
      dispatch(actions.conversationToggleFocusMode(false));
    }
  }, [csid, dispatch]);

  const tooltip = (
    <CommandKeybindingsTooltipContent commandName="conversation:toggleConversationFocusMode">
      Toggle Focus Mode
    </CommandKeybindingsTooltipContent>
  );
  return (
    <Tooltip content={tooltip}>
      <IconButton
        variant="tertiary"
        icon={isFocusMode ? 'compress' : 'arrow-expand'}
        onClick={toggleExpandedView}
      />
    </Tooltip>
  );
};
